/* as.if.radio - die Buehne (snippets/asif-radio-widget.liquid), Runde 7.
   Liest den Zustand aus assets/asif-radio-player.js und rendert, was der
   Player nicht selbst schreibt: Album, "bis hh:mm" der laufenden Sendung,
   den Heute-Streifen, die Textgroesse langer Titel, die drehende Platte,
   den Radio-Modus (dunkle Buehne auf der Startseite, Theme-Color).

   Die Sendungsprofile (nach Pierres Vorlagen vom 02.09.2026 neu geschrieben,
   mit Genres und Farbplatzhaltern ergänzt am 22.09.2026) liegen hier, weil die
   Buehne auf beiden Seiten laeuft; die Radioseite (broadcast-radio-page.js)
   greift ueber window.AsIfRadioProgrammes darauf zu. Neue Sendung: hier
   eintragen, Schluessel = Handle aus der API (Punkte zu Bindestrichen).

   SPA-Vertrag (asif-spa.js): mount() ist idempotent, Aufraeumen ueber
   asif:page:unload und shopify:section:unload. */
(() => {
  'use strict';

  const mounts = window.__asifRadioWidgetMounts || new Map();
  window.__asifRadioWidgetMounts = mounts;

  const programmes = {
    'daily-pleasure': { genre: 'Soul · Indie · Hip-Hop', color: '#c7bc67', title: 'daily.pleasure', tagline: 'Platten aus unserer täglichen Rotation.', description: 'Soul, Indie und Hip-Hop, dazu House, Funk und Musik aus Brasilien. Neue Releases und Platten, zu denen wir immer wieder zurückkommen.' },
    'coffee-first': { genre: 'Indie-Pop · Soul · Hip-Hop', color: '#d8b393', title: 'coffee.first', tagline: 'Indie, Soul und Beats am Morgen.', description: 'Indie-Pop, Soul und Hip-Hop am Morgen. Dazwischen Elektronik und Gitarren, ohne feste Reihenfolge.' },
    'cloud-nine': { genre: 'Neo-Soul · R&B · Soul', color: '#bba3c8', title: 'cloud.nine', tagline: 'Neo-Soul, R&B und Soul.', description: 'Neo-Soul und R&B mit Soul im Hintergrund. Stimmen im Vordergrund, Bass und Beats darunter.' },
    'soul-crates': { genre: 'Soul · Funk · Jazz-Funk', color: '#c68f73', title: 'soul.crates', tagline: 'Soul, Funk und die B-Seiten.', description: 'Soul und Funk, Singles und weniger gespielte Albumtracks. Dazu Jazz-Funk, R&B und Disco.' },
    'block-party': { genre: 'Hip-Hop · Boom Bap · Jazz-Rap', color: '#cda878', title: 'block.party', tagline: 'Rapplatten und ihre Samples.', description: 'Hip-Hop mit Schwerpunkt auf Boom Bap und Jazz-Rap. Rapklassiker, Jazz- und Funk-Samples, dazwischen R&B und Neo-Soul.' },
    'boom-bap-bonfire': { genre: 'Jazz-Rap · Boom Bap · Lo-Fi', color: '#a8b68a', title: 'boom.bap.bonfire', tagline: 'Jazz-Samples und instrumentale Beats.', description: 'Jazz-Rap, Boom Bap und Lo-Fi. Gesampelte Jazzplatten, lose gesetzte Drums und instrumentaler Hip-Hop, mit Abstechern in Downtempo und Trip-Hop.' },
    'tape-dust': { genre: 'Deutschrap · Boom Bap · Jazz-Rap', color: '#a5afc9', title: 'tape.dust', tagline: 'Deutschrap, Boom Bap und Jazz-Samples.', description: 'Deutschrap zwischen Boom Bap und Jazz-Produktionen. Loops und Samples, unterschiedliche Flows, gelegentlich Trap.' },
    'mixed-tapes': { genre: 'Jazz · Rare Groove · Hip-Hop', color: '#bb9d83', title: 'mixed.tapes', tagline: 'DJ-Sets aus unserem Archiv.', description: 'Jazz, Rare Groove und Hip-Hop, Funk, House und UK Garage. Jedes Set hat seine eigene Auswahl und nimmt sich Zeit für die Übergänge.' },
    'indie-undercurrents': { genre: 'Indie-Pop · Psych-Rock · Dream-Pop', color: '#8eaca1', title: 'indie.undercurrents', tagline: 'Indie-Pop, Dream-Pop und Psychedelia.', description: 'Indie-Pop, Psych-Rock und Dream-Pop. Gitarren mit viel Hall, Synths und Melodien, die auch mal Umwege nehmen. Dazwischen Downtempo und Elektronik.' },
    'riot-school': { genre: 'Indie-Rock · Alternative Rock · Metal', color: '#cb827b', title: 'riot.school', tagline: 'Indie, Post-Punk und Gitarren für den Dancefloor.', description: 'Indie-Rock, Post-Punk und Alternative, mit Abstechern in Garage und Metal. Vertraute Platten, neue Bands und Gitarrenmusik für den Dancefloor.' },
    'boomer-boom-box': { genre: 'Pop · Synth-Pop · Classic Rock', color: '#d1a0b7', title: 'boomer.boom.box', tagline: 'Singles und Albumtracks der 80er und 90er.', description: 'Pop, Synth-Pop und Rock aus den 80ern und 90ern. Bekannte Singles neben Albumtracks, die seltener im Radio laufen.' },
    'global-joyride': { genre: 'MPB · Bossa Nova · Latin', color: '#c1ac73', title: 'global.joyride', tagline: 'Brasilianische Platten und ihre Verbindungen.', description: 'MPB und Bossa Nova, dazu Latin, Funk und Afrobeat. Ein Schwerpunkt auf brasilianischer Musik, auch dort, wo sie psychedelisch wird.' },
    'deep-roots': { genre: 'Amapiano · Afro-House · Afrobeats', color: '#8ba57a', title: 'deep.roots', tagline: 'Amapiano, Afro-House und Afrobeats.', description: 'Amapiano, Afro-House und Afrobeats, mit Deep House dazwischen. Log-Drums, Percussion und Bass bestimmen den Takt.' },
    'heatwave-honey': { genre: 'Nu-Disco · House · Downtempo', color: '#d9ab64', title: 'heatwave.honey', tagline: 'Disco-Edits, House und Downtempo.', description: 'Nu-Disco, House und Disco-Edits. Bassläufe aus der Disco, Drum Machines aus dem Club, dazwischen Deep House und Downtempo.' },
    'cosmo-club': { genre: 'Indie · Alternative · Electronica', color: '#83afb6', title: 'cosmo.club', tagline: 'Neue Releases und Platten aus dem Archiv.', description: 'Indie, Alternative und Electronica, dazu Hip-Hop, Soul und House. Neue Bands und aktuelle Releases neben Platten aus dem Archiv.' },
    'basement-house': { genre: 'House · Deep House · Tech House', color: '#9994bc', title: 'basement.house', tagline: 'House, Deep House und UK Garage.', description: 'House und Deep House, mit Abstechern in Tech House und UK Garage. Drum Machines, Bass und wiederkehrende Akkorde, Tracks für längere Übergänge.' },
    'crooked-radio-show': { genre: 'Genreoffen', color: '#bd91a0', title: 'crooked.radio.show', tagline: 'Alle zwei Wochen andere Genres.', description: 'Alle zwei Wochen nehmen wir andere Genres auseinander: die Platten, die Einflüsse und die Szenen dahinter. Kein festes musikalisches Revier.' },
    'crooked-radio-rewind': { genre: 'Genreoffen', color: '#bd91a0', title: 'crooked.radio.rewind', tagline: 'Die letzte Ausgabe noch einmal hören.', description: 'Die Wiederholung der crooked.radio.show. Noch einmal Zeit für die Platten und Geschichten der letzten Ausgabe, bevor es mit anderen Genres weitergeht.' },
    'midnight-ride': { genre: 'Downtempo · Deep House · Indie-Pop', color: '#849db9', title: 'midnight.ride', tagline: 'Downtempo, Deep House und Indie-Pop.', description: 'Downtempo, Deep House und Indie-Pop für die Nacht. Zwischen Clubtracks und Popsongs, mit mehr Raum für die ruhigeren Stücke.' }
  };

  const programmeKey = (item) => String(item?.programHandle || item?.handle || item?.title || '')
    .toLowerCase().replace(/\./g, '-').replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '');
  const programmeTitle = (item) => String(item?.title || 'as.if.radio').replace(/_/g, ' ');
  const profileFor = (item) => programmes[programmeKey(item)] || { title: programmeTitle(item), tagline: '', description: '' };

  // The manifest lives in the widget markup and follows SPA/section replacement.
  const coverManifests = new WeakMap();
  const createCover = (item, className, size) => {
    const box = document.createElement('span');
    box.className = className;
    box.setAttribute('aria-hidden', 'true');
    box.style.setProperty('--show-color', profileFor(item).color || '#b8ac9a');
    const manifest = document.querySelector('[data-radio-programme-covers]');
    if (manifest && !coverManifests.has(manifest)) {
      try { coverManifests.set(manifest, JSON.parse(manifest.textContent)); }
      catch (_) { coverManifests.set(manifest, {}); }
    }
    const src = coverManifests.get(manifest)?.[programmeKey(item)];
    if (src) {
      const image = document.createElement('img');
      image.alt = ''; // The adjacent programme name already labels this decoration.
      image.width = size;
      image.height = size;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', () => image.remove(), { once: true });
      image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
      image.src = src;
      if (image.complete && image.naturalWidth) image.classList.add('is-loaded'); // aus dem Cache: nicht neu einblenden
      box.append(image);
    }
    return box;
  };

  window.AsIfRadioProgrammes = Object.freeze({ profileFor, programmeKey, programmeTitle, createCover, profiles: programmes });

  const formatTime = (value) => new Intl.DateTimeFormat('de-DE', {
    timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).format(new Date(value));

  const berlinDayKey = (value) => new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'
  }).format(new Date(value));

  // Gleiches Format wie slotAnchor() in broadcast-radio-page.js.
  const slotAnchor = (item) => {
    const handle = String(item?.programHandle || item?.title || 'sendung').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'sendung';
    return `programm-${handle}-${berlinDayKey(item.startsAt)}-${formatTime(item.startsAt).replace(':', '')}`;
  };

  const fitText = (node, value, longAt, extraLongAt) => {
    if (!node) return;
    const length = Array.from(String(value || '').trim()).length;
    const fit = length > extraLongAt ? 'xlong' : length > longAt ? 'long' : 'normal';
    if (node.dataset.fit !== fit) node.dataset.fit = fit;
  };

  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };

  const orderedSchedule = (items) => (items || [])
    .filter((item) => item?.startsAt && item?.endsAt && item?.title)
    .slice()
    .sort((first, second) => new Date(first.startsAt) - new Date(second.startsAt));

  const currentSlot = (items, now) => items.find((item) => new Date(item.startsAt).getTime() <= now && new Date(item.endsAt).getTime() > now) || null;

  /* --- Radio-Modus: dunkel, sobald das Radio eine Sitzung hat --------- */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sessionActive = false;

  // Sitzung nur, solange das Radio laufen will. Pause = zurueck zum Alten.
  const hasSession = (state) => Boolean(state && (state.wantsToPlay || state.playing || state.loading || state.needsResume
    || ['playing', 'buffering', 'connecting', 'retrying'].includes(state.status)));

  // Neue Startseite (body.asif-home, 23.09.2026): Die Buehne ist dort hell und
  // taucht erst beim Druck auf Play ins Dunkle (onPlay). Der Radio-Modus
  // faerbt dort deshalb weder Kopf noch Seite um.
  const syncRadioMode = () => {
    const onRadio = document.body.classList.contains('asif-radio-product');
    const onHome = document.body.classList.contains('asif-home');
    const active = onRadio || (sessionActive && !onHome);
    if (active) document.documentElement.dataset.asifRadioMode = 'active';
    else delete document.documentElement.dataset.asifRadioMode;
    const meta = document.querySelector('meta[data-asif-theme-color]');
    // Startseite: Browserleiste in der Farbe der Buehne (asif-home.js setzt --aura-base).
    const homeBase = onHome ? document.body.dataset.auraBase : '';
    if (meta) meta.content = active ? '#181a1a' : (homeBase || '#f2efe6');
  };

  /* --- Heute-Streifen: laufende Sendung und was heute noch kommt -------- */
  const renderStrip = (root, items, status) => {
    const list = root.querySelector('[data-radio-widget-schedule]');
    if (!list) return;
    const now = Date.now();
    const ordered = orderedSchedule(items);
    const firstRelevant = ordered.findIndex((item) => new Date(item.endsAt).getTime() > now);
    let visible = firstRelevant >= 0 ? ordered.slice(firstRelevant) : [];
    const today = berlinDayKey(new Date());
    const todays = visible.filter((item) => berlinDayKey(item.startsAt) === today);
    visible = (todays.length ? todays : visible).slice(0, 6);

    const head = root.querySelector('.stage__strip > .stage__label');
    if (head) setText(head, todays.length ? 'Heute' : 'Morgen');

    if (!visible.length) {
      const note = document.createElement('li');
      note.className = 'stage__slot stage__slot--note';
      note.textContent = status === 'unavailable'
        ? (root.dataset.scheduleError || 'Programm gerade nicht erreichbar.')
        : status === 'empty' ? 'Heute ist noch kein Programm eingetragen.' : (root.dataset.scheduleLoading || 'Programm wird geladen.');
      list.replaceChildren(note);
      return;
    }

    const isRadioPage = root.dataset.radioContext === 'radio';
    list.replaceChildren(...visible.map((item) => {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'stage__slot';
      link.href = `${isRadioPage ? '' : '/pages/radio'}#${slotAnchor(item)}`;
      const isNow = new Date(item.startsAt).getTime() <= now && new Date(item.endsAt).getTime() > now;
      if (isNow) link.classList.add('is-now');
      const time = document.createElement('time');
      time.dateTime = item.startsAt;
      time.textContent = `${formatTime(item.startsAt)}-${formatTime(item.endsAt)}`;
      const title = document.createElement('strong');
      title.textContent = programmeTitle(item);
      link.append(createCover(item, 'stage__show-cover', 40), time, title);
      li.append(link);
      return li;
    }));
  };

  /* --- Die Platte: dreht immer, schneller mit Ton, still ausser Sicht --- */
  const setupRecord = (root) => {
    const record = root.querySelector('[data-stage-record]');
    if (!record || typeof record.animate !== 'function') return { setPlaying() {}, cleanup() {} };
    let spin = null;
    let inView = true;
    let playing = false;

    const sync = () => {
      if (reduceMotion.matches) { spin?.cancel(); spin = null; return; }
      if (!spin) {
        spin = record.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], { duration: 18000, iterations: Infinity, easing: 'linear' });
        // Weicher Seitenwechsel: Die neue Platte dreht dort weiter, wo die alte stand.
        if (typeof window.__asifRecordPhase === 'number') { spin.currentTime = window.__asifRecordPhase; delete window.__asifRecordPhase; }
      }
      spin.playbackRate = playing ? 2 : 1;
      if (inView && !document.hidden) { if (spin.playState !== 'running') spin.play(); }
      else if (spin.playState === 'running') spin.pause();
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      inView = entries.some((entry) => entry.isIntersecting);
      sync();
    }, { threshold: 0.01 }) : null;
    observer?.observe(record);
    const onVisibility = () => sync();
    document.addEventListener('visibilitychange', onVisibility);
    reduceMotion.addEventListener?.('change', sync);
    sync();

    return {
      setPlaying(next) { if (playing !== next) { playing = next; sync(); } },
      phase() { return spin && typeof spin.currentTime === 'number' ? spin.currentTime % 18000 : null; },
      cleanup() {
        observer?.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        reduceMotion.removeEventListener?.('change', sync);
        // Pause statt cancel: Bis zum Seitentausch bleibt die Platte stehen,
        // wo sie ist, statt auf 0 Grad zurueckzuspringen.
        spin?.pause();
      }
    };
  };

  /* Aktionen am Handy: alle sichtbaren nebeneinander, gleich breit; ab drei
     nur Symbole (die Beschriftung bleibt als aria-label). */
  const syncActions = (root) => {
    const actions = root.querySelector('.stage__actions');
    if (!actions) return;
    const visible = [...actions.querySelectorAll('.stage__action')].filter((node) => !node.hidden && window.getComputedStyle(node).display !== 'none').length;
    if (actions.dataset.count !== String(visible)) actions.dataset.count = String(visible);
    actions.style.setProperty('--stage-n', String(Math.max(1, visible)));
  };

  // Visual state only: never schedules, pauses or replaces an audio source.
  const setupArtworkTransition = (image, onReady = () => {}, opacity = 1) => {
    if (!image) return () => {};
    let shown = image.complete && image.naturalWidth ? image.src : '';
    let pending = image.src;
    let loadedSource = shown;
    let outgoing = null;
    let animation = null;
    let disposed = false;
    const clear = () => {
      const oldAnimation = animation;
      animation = null;
      oldAnimation?.cancel();
      outgoing?.remove();
      outgoing = null;
    };
    const loaded = () => {
      if (disposed || image.src !== pending || image.src === loadedSource || !image.complete || !image.naturalWidth) return;
      loadedSource = image.src;
      shown = image.src;
      onReady(shown);
      if (!outgoing) return;
      if (reduceMotion.matches || document.hidden || typeof outgoing.animate !== 'function') { clear(); return; }
      const layer = outgoing;
      animation = layer.animate([{ opacity }, { opacity:0 }], { duration:320, easing:'cubic-bezier(.2,0,0,1)', fill:'forwards' });
      animation.finished.then(() => { if (outgoing === layer) clear(); }, () => {});
    };
    const changed = () => {
      if (image.src === pending) return;
      pending = image.src;
      clear();
      if (shown && !reduceMotion.matches && !document.hidden) {
        outgoing = document.createElement('img');
        outgoing.className = 'stage__art-outgoing';
        outgoing.alt = '';
        outgoing.setAttribute('aria-hidden', 'true');
        outgoing.src = shown;
        image.parentElement.append(outgoing);
      }
      loaded(); // Cached resources may already have completed before observation.
    };
    const failed = () => { clear(); }; // The owning player supplies its existing fallback.
    const reduced = () => { if (reduceMotion.matches) clear(); };
    const observer = new MutationObserver(changed);
    observer.observe(image, { attributes:true, attributeFilter:['src'] });
    image.addEventListener('load', loaded);
    image.addEventListener('error', failed);
    reduceMotion.addEventListener?.('change', reduced);
    if (shown) onReady(shown);
    return () => {
      disposed = true;
      observer.disconnect();
      image.removeEventListener('load', loaded);
      image.removeEventListener('error', failed);
      reduceMotion.removeEventListener?.('change', reduced);
      clear();
    };
  };

  function mount(root) {
    if (!root || mounts.has(root)) return;
    let lastScheduleSignature = '';
    let lastState = null;
    let clock = 0;
    const record = setupRecord(root);
    root.__asifRecord = record;
    const readyFallback = window.setTimeout(() => { root.dataset.ready = 'true'; }, 2500);
    const ambience = root.querySelector('[data-stage-atmosphere]');
    const visualCleanups = [];
    const textAnimations = new Set();
    let lastTrack = '';
    const stopTextMotion = () => { if (reduceMotion.matches) { textAnimations.forEach(animation => animation.cancel()); textAnimations.clear(); } };
    reduceMotion.addEventListener?.('change', stopTextMotion);
    if (ambience) {
      visualCleanups.push(setupArtworkTransition(ambience, () => {}, .65));
      visualCleanups.push(setupArtworkTransition(root.querySelector('[data-asif-radio-art]'), src => {
        if (ambience.src !== src) ambience.src = src;
      }));
    }

    const applyState = (state) => {
      if (!state) return;
      lastState = state;
      if (document.hidden) return;
      const track = `${state.title || ''}|${state.artist || ''}`;
      if (lastTrack && lastTrack !== track && ambience && !reduceMotion.matches && !document.hidden) {
        textAnimations.forEach(animation => animation.cancel());
        textAnimations.clear();
        [...root.querySelectorAll('.stage__title,.stage__artist,.stage__band-title,.stage__band-artist'), ...document.querySelectorAll('[data-hub-title],[data-hub-artist],[data-hub-art]')].forEach(node => {
          if (typeof node.animate !== 'function') return;
          const animation = node.animate([{ opacity:.3, transform:'translateY(4px)' }, { opacity:1, transform:'translateY(0)' }], { duration:240, easing:'cubic-bezier(.2,0,0,1)' });
          textAnimations.add(animation);
          animation.finished.then(() => textAnimations.delete(animation), () => textAnimations.delete(animation));
        });
      }
      lastTrack = track;
      root.dataset.state = state.status || 'idle';
      record.setPlaying(['playing', 'buffering'].includes(state.status));
      root.querySelectorAll('[data-stage-play-label]').forEach((node) => setText(node, hasSession(state) ? 'Zum Radio' : 'Radio an'));
      root.querySelectorAll('[data-asif-radio-title]').forEach((node) => fitText(node, state.title, 26, 44));
      root.querySelectorAll('[data-asif-radio-artist]').forEach((node) => fitText(node, state.artist, 34, 58));
      const album = state.album && state.album !== state.title ? state.album : '';
      root.querySelectorAll('[data-stage-album]').forEach((node) => setText(node, album));
      root.querySelectorAll('[data-stage-track-info]').forEach(button => {
        button.disabled = !state.trackId;
        button.setAttribute('aria-label', `${state.title || 'Aktueller Titel'}${state.artist ? ` von ${state.artist}` : ''}: Trackinfos öffnen`);
      });
      syncActions(root);

      // Erst zeigen, wenn Titel und Programm da sind (asif-radio-widget.css
      // blendet dann weich ein), statt Platzhalter aufploppen zu lassen.
      if (!root.dataset.ready && state.metadataStatus && state.metadataStatus !== 'loading'
        && !['idle', 'loading'].includes(state.scheduleStatus || 'idle')) root.dataset.ready = 'true';
      const ordered = orderedSchedule(state.schedule);
      const slot = currentSlot(ordered, Date.now());
      root.querySelectorAll('[data-stage-until]').forEach((node) => setText(node, slot ? `bis ${formatTime(slot.endsAt)}` : ''));

      const signature = `${state.scheduleStatus}${ordered.map((item) => `${item.id}|${item.startsAt}|${item.endsAt}`).join('')}${slot?.id || ''}`;
      if (signature !== lastScheduleSignature) {
        lastScheduleSignature = signature;
        renderStrip(root, ordered, state.scheduleStatus);
      }
    };

    // Startseite: Radio an und direkt auf die Radioseite, weich wenn moeglich.
    const onPlay = (event) => {
      const info = event.target.closest('[data-stage-track-info]');
      if (info && root.contains(info)) {
        if (!info.disabled) document.dispatchEvent(new CustomEvent('asif:track:open', { detail: { source: 'current', opener: info } }));
        return;
      }
      const button = event.target.closest('[data-stage-play]');
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      const target = '/pages/radio';
      try { if (!hasSession(window.AsIfRadio?.getState?.())) window.AsIfRadio?.play?.(); } catch (error) {}
      const go = () => {
        if (window.AsIfSpa?.navigate && window.AsIfSpa.listening?.()) window.AsIfSpa.navigate(target);
        else window.location.assign(target);
      };
      // Startseite neu: Die helle Buehne taucht ins Dunkle, waehrend die
      // Radioseite schon geladen wird. Den Tausch selbst blendet asif-spa.js
      // per View Transition ueber (html.asif-diving), alle Elemente liegen auf
      // beiden Seiten gleich. Ohne Bewegung oder ohne SPA: direkt wechseln.
      if (root.dataset.radioContext === 'index' && !reduceMotion.matches) {
        if (root.classList.contains('is-diving')) return;
        // Radioseite sofort im Hintergrund holen, aber erst einsetzen, wenn die
        // Buehne fertig abgedunkelt ist: So laeuft die Blende ohne Ruckler,
        // weil der Browser waehrenddessen nichts Grosses verarbeiten muss.
        window.AsIfSpa?.prefetch?.(target);
        startDive(root);
        if (window.scrollY > 0) window.scrollTo({ top: 0, behavior: 'smooth' });
        window.setTimeout(go, DIVE_MS);
        return;
      }
      go();
    };
    root.addEventListener('click', onPlay);

    const handleState = (event) => applyState(event.detail);
    const handleReady = () => {
      window.AsIfRadio?.ensureData({ schedule: true });
      if (window.AsIfRadio?.getState) applyState(window.AsIfRadio.getState());
    };
    window.addEventListener('asif:radio-state', handleState);
    window.addEventListener('asif:radio-ready', handleReady);
    // Einmal pro Minute nachsehen, ob die Sendung gewechselt hat.
    const onVisibility = () => {
      window.clearInterval(clock); clock = 0;
      if (document.hidden) return;
      lastScheduleSignature = ''; applyState(lastState);
      clock = window.setInterval(() => { lastScheduleSignature = ''; applyState(lastState); }, 60000);
    };
    document.addEventListener('visibilitychange', onVisibility);
    onVisibility();

    mounts.set(root, () => {
      window.clearTimeout(readyFallback);
      window.clearInterval(clock);
      document.removeEventListener('visibilitychange', onVisibility);
      record.cleanup();
      visualCleanups.forEach(cleanup => cleanup());
      reduceMotion.removeEventListener?.('change', stopTextMotion);
      textAnimations.forEach(animation => animation.cancel());
      textAnimations.clear();
      root.removeEventListener('click', onPlay);
      window.removeEventListener('asif:radio-state', handleState);
      window.removeEventListener('asif:radio-ready', handleReady);
      mounts.delete(root);
    });

    if (window.AsIfRadio) handleReady();
  }

  /* --- Eintauchen von der Startseite ins Radio (23.09.2026) -------------
     Ueber die helle Atmosphaere legt sich die dunkle der Radioseite (nur
     Deckkraft, laeuft auf der Grafikkarte). Farben der Buehne und des Kopfs
     wechseln per CSS (.is-diving, html.asif-diving, asif-home.css). */
  const DIVE_MS = 560;
  const startDive = (root) => {
    document.documentElement.classList.add('asif-diving');
    const atmosphere = root.querySelector('.stage__atmosphere');
    const art = root.querySelector('[data-asif-radio-art]');
    if (atmosphere && !atmosphere.querySelector('.stage__dive')) {
      const layer = document.createElement('div');
      layer.className = 'stage__dive';
      layer.setAttribute('aria-hidden', 'true');
      const src = art?.currentSrc || art?.src;
      if (src) {
        const image = document.createElement('img');
        image.alt = '';
        image.src = src;
        layer.append(image);
      }
      atmosphere.append(layer);
    }
    void root.offsetWidth; // Startzustand festhalten, damit die Blende laeuft.
    root.classList.add('is-diving');
  };

  // Kurz vor dem Einsetzen der neuen Seite (asif-spa.js): Titel, Cover und
  // Plattenstellung uebernehmen, damit nichts auf "wird geladen" zurueckfaellt.
  document.addEventListener('asif:page:before-swap', (event) => {
    const next = event.detail?.main;
    if (!next) return;
    const current = document.querySelector('main [data-asif-radio-widget]');
    const incoming = next.querySelector('[data-asif-radio-widget]');
    if (!current || !incoming) return;
    const phase = current.__asifRecord?.phase?.();
    if (typeof phase === 'number') {
      window.__asifRecordPhase = phase;
      // Bis die neue Buehne ihre Drehung startet, steht die Platte im selben Winkel.
      const record = incoming.querySelector('[data-stage-record]');
      if (record) record.style.transform = `rotate(${(phase / 18000) * 360}deg)`;
    }
    // App-Knopf der Radioseite gleich zeigen, wie es asif-radio-pwa.js
    // ohnehin tut, solange die App nicht installiert ist. Sonst steht der
    // Platz, auf dem eben noch Play war, kurz leer.
    const standalone = window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!standalone) incoming.querySelectorAll('[data-app-open]').forEach((button) => { button.hidden = false; });
    const actions = current.querySelector('.stage__actions');
    const nextActions = incoming.querySelector('.stage__actions');
    if (actions && nextActions) {
      const count = actions.style.getPropertyValue('--stage-n');
      if (count) nextActions.style.setProperty('--stage-n', count);
      if (actions.dataset.count) nextActions.dataset.count = actions.dataset.count;
    }
    incoming.dataset.ready = 'true';
    const copyText = (selector) => {
      const source = current.querySelector(selector);
      if (!source) return;
      incoming.querySelectorAll(selector).forEach((node) => { node.textContent = source.textContent; if (source.dataset.fit) node.dataset.fit = source.dataset.fit; });
    };
    ['.stage__title', '.stage__artist', '.stage__band-title', '.stage__band-artist', '.stage__album', '[data-stage-until]'].forEach(copyText);
    const art = current.querySelector('[data-asif-radio-art]');
    const src = art?.currentSrc || art?.src;
    if (src) {
      incoming.querySelectorAll('[data-asif-radio-art], [data-stage-atmosphere]').forEach((image) => { image.src = src; });
    }
    const strip = current.querySelector('[data-radio-widget-schedule]');
    const nextStrip = incoming.querySelector('[data-radio-widget-schedule]');
    if (strip && nextStrip && strip.children.length) {
      nextStrip.replaceChildren(...[...strip.children].map((item) => item.cloneNode(true)));
      const toRadio = incoming.dataset.radioContext === 'radio';
      nextStrip.querySelectorAll('a.stage__slot').forEach((link) => {
        const hash = link.getAttribute('href')?.split('#')[1];
        if (hash) link.setAttribute('href', toRadio ? `#${hash}` : `/pages/radio#${hash}`);
      });
    }
  });
  document.addEventListener('asif:page', () => {
    window.setTimeout(() => document.documentElement.classList.remove('asif-diving', 'asif-surfacing'), 900);
  });
  window.addEventListener('pageshow', () => document.documentElement.classList.remove('asif-diving', 'asif-surfacing'));

  const mountAll = () => document.querySelectorAll('[data-asif-radio-widget]').forEach(mount);

  window.addEventListener('asif:radio-state', (event) => {
    const next = hasSession(event.detail);
    if (next !== sessionActive) { sessionActive = next; syncRadioMode(); }
  });
  window.addEventListener('asif:radio-ready', () => {
    sessionActive = hasSession(window.AsIfRadio?.getState?.());
    syncRadioMode();
  });
  if (window.AsIfRadio?.getState) sessionActive = hasSession(window.AsIfRadio.getState());
  syncRadioMode();
  mountAll();
  // SPA-Vertrag (asif-spa.js): Seitentausch ohne Neuladen.
  document.addEventListener('asif:page', (event) => {
    if (event.detail?.initial) return;
    syncRadioMode();
    mountAll();
  });
  document.addEventListener('asif:page:unload', () => {
    mounts.forEach((cleanup, root) => { if (!root.isConnected || root.closest('main')) cleanup(); });
  });
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-asif-radio-widget]').forEach(mount);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    mounts.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); });
  });
})();
